import type { CityConfig } from "../city-template/types";

export const fortWayneConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Fort Wayne",
  state: "Indiana",
  stateAbbr: "IN",
  slug: "fort-wayne",
  route: "/cities/fort-wayne",
  title: "Emergency Passport Fort Wayne, IN — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Fort Wayne, Indiana — as fast as 24 hours. Fast passport renewal and new passport applications for Fort Wayne, New Haven, Huntington, Columbia City, and all Northeast Indiana residents. A+ BBB rated.",
  h1: "Emergency & Expedited Passport Services in Fort Wayne, IN",
  heroSubtitle: "Fort Wayne travelers — from the Allen County business corridor to the Purdue Fort Wayne campus to the Northeast Indiana manufacturing community — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. A+ BBB rated courier service serving all of Allen County and Northeast Indiana.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Fort%20Wayne%20Indiana%20downtown%20skyline%20with%20the%20historic%20Allen%20County%20Courthouse%2C%20modern%20riverfront%20buildings%20along%20the%20St.%20Joseph%20River%2C%20well-maintained%20urban%20parks%2C%20warm%20afternoon%20sunlight%2C%20professional%20city%20photography%2C%20clean%20Midwestern%20atmosphere%2C%20no%20text%20or%20people%2C%20editorial%20style%20urban%20photography%20with%20warm%20golden%20tones%20and%20architectural%20heritage%20details&width=1800&height=700&seq=fortwayne-hero-001&orientation=landscape",
  heroImageAlt: "Fort Wayne Indiana downtown skyline with Allen County Courthouse and St. Joseph River",
  geoPosition: "41.0798;-85.1394",
  geoPlacename: "Fort Wayne, Indiana",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "230 S Dearborn St Suite 380, Chicago IL 60604",
    distance: "Approximately 140 miles, 2 hours via I-69",
  },
  nearbyCitiesZips: [
    { name: "Fort Wayne", zips: "46801, 46802, 46803, 46804, 46805, 46806, 46807, 46808, 46809, 46814, 46815, 46816, 46818, 46819, 46825, 46835, 46845, 46850, 46851, 46852, 46853, 46854, 46855, 46856, 46857, 46858, 46859, 46860, 46861, 46862, 46863, 46864, 46865, 46866, 46867, 46868, 46869, 46885, 46895, 46897, 46898, 46899" },
    { name: "New Haven", zips: "46774" },
    { name: "Huntington", zips: "46750" },
    { name: "Columbia City", zips: "46725" },
    { name: "Auburn", zips: "46706" },
    { name: "Kendallville", zips: "46755" },
    { name: "Angola", zips: "46703" },
    { name: "Decatur", zips: "46733" },
    { name: "Bluffton", zips: "46714" },
    { name: "Wabash", zips: "46992" },
    { name: "Marion", zips: "46952, 46953" },
    { name: "Kokomo", zips: "46901, 46902, 46903, 46904" },
    { name: "Muncie", zips: "47302, 47303, 47304, 47305, 47306, 47307" },
    { name: "Anderson", zips: "46011, 46012, 46013, 46014, 46015, 46016, 46017, 46018" },
    { name: "Noblesville", zips: "46060, 46061, 46062" },
    { name: "Fishers", zips: "46037, 46038, 46040, 46085" },
    { name: "Indianapolis", zips: "46201, 46202, 46203, 46204, 46205, 46206, 46208, 46214, 46217, 46218, 46219, 46220, 46221, 46222, 46224, 46225, 46226, 46227, 46228, 46229, 46231, 46234, 46235, 46236, 46237, 46239, 46240, 46241, 46250, 46254, 46256, 46259, 46260, 46268, 46278, 46280, 46290" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier to Chicago or Indianapolis — our couriers pick the fastest route" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-building-line", title: "Northeast Indiana Hub", desc: "Serving Purdue Fort Wayne, Allen County businesses, and manufacturing travel" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — no road trip to Chicago or Indy required" },
  ],
  internalLinks: [
    { name: "Expedited passport in Indianapolis, IN", route: "/cities/indianapolis" },
    { name: "Emergency passport help in Evansville, IN", route: "/evansville" },
    { name: "Urgent passport services in Carmel, IN", route: "/cities/carmel" },
    { name: "Indiana passport services overview", route: "/states/indiana" },
  ],
  fpcOfficeAddress: "230 S Dearborn St Suite 380, Chicago IL 60604",
  fpcOfficeNote: "Fast Passport Center serves Fort Wayne, Indiana remotely via secure registered courier. Our registered couriers hand-deliver your documents to the Chicago Passport Agency (230 S Dearborn St Suite 380, Chicago IL 60604 — 2 hours west via I-69/I-80). Fort Wayne residents can ship from any UPS or FedEx in Allen County.",
  fpcOfficeDistance: "Serving Fort Wayne, New Haven, Huntington, Columbia City, Auburn, Kendallville, Angola, Decatur, Bluffton, Wabash, Marion, Kokomo, and all of Northeast Indiana",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Fort Wayne and Northeast Indiana. From downtown Fort Wayne near the St. Joseph River to the Purdue Fort Wayne campus, from New Haven to the Columbia City and Auburn communities — we serve all of Allen County and beyond.",
  nearbyCitiesIntro: "We serve Fort Wayne and all nearby communities including New Haven, Huntington, Columbia City, Auburn, Kendallville, Angola, Decatur, Bluffton, Wabash, Marion, Kokomo, Muncie, Anderson, Noblesville, Fishers, and Indianapolis. We also serve all of Allen, Huntington, Whitley, DeKalb, and Steuben counties.",
  howItWorksIntro: "Most Fort Wayne travelers complete everything online and ship documents overnight. No need to drive 3 hours to Chicago or 2 hours to Indianapolis — our couriers handle both agencies and always pick the fastest route.",
  mistakesIntro: "Fort Wayne is a major Northeast Indiana hub with significant university travel from Purdue Fort Wayne and business travel from the Allen County manufacturing corridor. Here are the most common passport mistakes we see from Northeast Indiana travelers.",
  testimonialsIntro: "Fort Wayne travelers — from Purdue Fort Wayne students to manufacturing professionals to Northeast Indiana families — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Fort Wayne, IN? Here are the most common ones we hear from Northeast Indiana travelers.",
  statePageRoute: "/states/indiana",
  statePageName: "Indiana",
  dmvWebsite: "https://www.in.gov/bmv",
  dmvLabel: "Indiana BMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Chicago or Indianapolis agency — fastest option chosen", "No long drive required", "Perfect for university and business travel deadlines", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Chicago or Indianapolis agency — fastest option chosen", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive 3 hours to Chicago or 2 hours to Indianapolis", "Full day commitment — difficult from Fort Wayne"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Fort Wayne travelers with immediate departure needs — as fast as 24 hours. Our couriers use Chicago or Indianapolis agency — whichever is fastest.",
      bullets: ["24–48 hour turnaround available", "Chicago or Indianapolis agency — fastest route chosen", "Northeast Indiana university and business travel support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Fort Wayne adults with a passport issued within the last 15 years. Skip the post office appointment entirely.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Northeast Indiana address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Fort Wayne residents and families — including Purdue Fort Wayne students, new citizens, and Northeast Indiana families.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Fort Wayne residents who lost their passport before international travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Fort Wayne and Northeast Indiana families with kids traveling internationally.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Fort Wayne and Northeast Indiana residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Fort Wayne IN", description: "Urgent passport processing for Fort Wayne Indiana travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Fort Wayne IN", description: "Fast passport renewal for Fort Wayne Indiana residents with a previously-issued passport." },
    { name: "First-Time Passport Fort Wayne IN", description: "New passport application services for Fort Wayne Indiana residents applying for their first passport." },
    { name: "Child Passport Fort Wayne IN", description: "Minor passport services for Fort Wayne Indiana families with children under 16." },
  ],
  testimonials: [
    {
      name: "Dr. Rachel M.",
      location: "Fort Wayne, IN",
      rating: 5,
      text: "Conference in Munich in 6 days and my passport was expired. Fast Passport Center had my renewed passport in 3 days. I shipped from the UPS Store on Jefferson and the whole process was seamless. Outstanding.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Thomas K.",
      location: "New Haven, IN",
      rating: 5,
      text: "Family vacation to Jamaica with 10 days notice. Four passports — two renewals and two first-time for our kids. Done in 5 days. We shipped from FedEx on Coliseum and everything was perfect.",
      service: "Family Passport Bundle",
    },
    {
      name: "Amanda S.",
      location: "Huntington, IN",
      rating: 5,
      text: "Business trip to Shanghai with 9 days notice. Fast Passport Center walked me through every step and had my passport in 3 days. The courier service is an absolute game-changer for Northeast Indiana.",
      service: "Emergency Passport",
    },
    {
      name: "James P.",
      location: "Fort Wayne, IN",
      rating: 5,
      text: "Lost my passport the week before a study abroad semester in Spain. Fast Passport Center replaced it in 48 hours. As a Purdue Fort Wayne student, I couldn't afford to miss my program. They saved my semester.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "fw-1",
      name: "Fort Wayne Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1501 S Harrison St",
      city: "Fort Wayne",
      state: "IN",
      zip: "46802",
      phone: "(260) 422-4541",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Fort Wayne, near the Allen County Courthouse",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary downtown Fort Wayne acceptance facility. Appointments required — book 1–2 weeks in advance. Convenient to downtown office workers.",
      icon: "ri-mail-line",
    },
    {
      id: "fw-2",
      name: "Aboite Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "10319 Aboite Center Rd",
      city: "Fort Wayne",
      state: "IN",
      zip: "46804",
      phone: "(260) 436-4551",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Southwest Fort Wayne, approximately 6 miles from downtown",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for southwest Fort Wayne and Aboite residents. Ample parking available.",
      icon: "ri-mail-line",
    },
    {
      id: "fw-3",
      name: "New Haven Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "720 Lincoln Hwy E",
      city: "New Haven",
      state: "IN",
      zip: "46774",
      phone: "(260) 749-1311",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "New Haven, approximately 8 miles east of downtown Fort Wayne",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves New Haven and eastern Allen County. Good alternative for east-side travelers.",
      icon: "ri-mail-line",
    },
    {
      id: "fw-4",
      name: "Huntington Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1240 S Jefferson St",
      city: "Huntington",
      state: "IN",
      zip: "46750",
      phone: "(260) 356-5297",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Huntington, approximately 25 miles southwest of Fort Wayne",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Huntington and southern Huntington County residents.",
      icon: "ri-mail-line",
    },
    {
      id: "fw-5",
      name: "Allen County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "715 S Calhoun St",
      city: "Fort Wayne",
      state: "IN",
      zip: "46802",
      phone: "(260) 449-7245",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Downtown Fort Wayne County Building",
      website: "https://www.allencounty.us/",
      websiteLabel: "Allen County",
      notes: "County Clerk passport acceptance. Extended hours compared to post office locations. Call to confirm current passport acceptance hours.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 140-mile, 2-hour drive to Chicago via I-69", fpc: "No — ship from Fort Wayne" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
    { feature: "NE Indiana Coverage", agency: "No local knowledge", fpc: "Yes — Purdue FW, Allen County expertise" },
    { feature: "Photo & Document Help", agency: "No guidance provided", fpc: "Yes — full document review included" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Fort Wayne professionals and university students often discover passport issues just before departure. Routine processing takes 6–13 weeks. Start expedited service at least 6 weeks before your trip.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Local photo services near Jefferson Boulevard or Coliseum Boulevard sometimes produce photos that meet ID requirements but fail passport standards. Photos must be exactly 2x2 inches on a white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 rejection reasons at Allen County acceptance facilities.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Not Booking Acceptance Facilities Early Enough",
      description: "Fort Wayne Post Office appointments fill during summer and winter break seasons. Book 2–3 weeks ahead.",
    },
    {
      icon: "ri-road-map-line",
      title: "Underestimating the Drive to Chicago",
      description: "Many Fort Wayne residents attempt to drive to Chicago in an emergency. The 3-hour drive each way means a full day lost — our courier service is faster and more reliable.",
    },
    {
      icon: "ri-time-line",
      title: "Assuming 4–6 Weeks Is Enough",
      description: "Routine processing takes 6–13 weeks. If your travel is within 10 weeks, use expedited service. Spring and summer travel from FWA peaks April through August.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in the Fort Wayne area or Northeast Indiana." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx near Jefferson Boulevard or Coliseum." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for small errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier submits to Chicago or Chicago Passport Agency — whichever is fastest for you." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Fort Wayne address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Fort Wayne, IN?", a: "Fast Passport Center offers emergency passport processing in Fort Wayne, Indiana in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Chicago Passport Agency (3 hours west via I-80/I-90) or Chicago Passport Agency (2 hours south via I-69) — whichever is fastest." },
    { q: "Does Fort Wayne have its own passport agency?", a: "No — Fort Wayne does not have a regional passport agency. The nearest facilities are the Chicago Passport Agency (approximately 3 hours west via I-80/I-90) and the Chicago Passport Agency (approximately 2 hours south via I-69). Fast Passport Center's courier service means Fort Wayne residents never need to make either drive." },
    { q: "Can I get an expedited passport in New Haven, Huntington, or Columbia City?", a: "Absolutely. Fast Passport Center serves all of Northeast Indiana including New Haven, Huntington, Columbia City, Auburn, Kendallville, Angola, and all of Allen, Huntington, Whitley, and Steuben counties. Our service works the same way everywhere." },
    { q: "What airport do Fort Wayne travelers use for international flights?", a: "Fort Wayne International Airport (FWA) is the primary airport for Fort Wayne and Northeast Indiana. FWA offers direct flights to Atlanta, Chicago, Detroit, and Dallas, with international connections through those hubs. Indianapolis International (IND) is also an option 2 hours south. Always verify passport validity for at least 6 months past your return date." },
    { q: "Should I use Indianapolis or Chicago for my passport?", a: "It depends on your timeline. The Chicago Passport Agency is 2 hours south via I-69 and may be less busy than Chicago. For some cases, it offers faster appointments. Fast Passport Center's couriers serve both agencies — we always choose the fastest option for your timeline." },
    { q: "How much does an expedited passport cost in Fort Wayne, IN?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Where can I get passport photos in Fort Wayne?", a: "Walgreens, CVS, and Walmart stores throughout Fort Wayne offer passport photos. UPS Store and FedEx Office locations also provide them. Photos must be 2x2 inches on a white background, taken within 6 months." },
    { q: "Does Fast Passport Center serve Purdue Fort Wayne students?", a: "Yes. Fast Passport Center serves all of Northeast Indiana including Purdue Fort Wayne students, faculty, and staff. We understand academic conference schedules and study abroad deadlines. Our courier service is especially valuable for students who can't take a day off to drive to Chicago." },
  ],
  photoLocations: [
    { name: "Walgreens — Jefferson Fort Wayne", address: "4610 S Anthony Blvd, Fort Wayne, IN 46806", hours: "Mon–Sun: 7AM–10PM", website: "https://www.walgreens.com/storelocator" },
    { name: "Walmart — Fort Wayne", address: "3801 N Clinton St, Fort Wayne, IN 46805", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/store/finder" },
    { name: "UPS Store — Fort Wayne", address: "6020 W Jefferson Blvd, Fort Wayne, IN 46804", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM", website: "https://www.theupsstore.com/tools/find-a-store" },
    { name: "FedEx Office — Coliseum", address: "1037 E Coliseum Blvd, Fort Wayne, IN 46805", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM", website: "https://www.fedex.com/en-us/location.html" },
  ],
  dmvLocations: [
    { name: "Indiana BMV — Fort Wayne", address: "5734 Coventry Ln, Fort Wayne, IN 46804", hours: "Mon–Fri: 8:30AM–6:00PM", note: "Indiana Bureau of Motor Vehicles for driver's licenses and REAL ID. Online reservations strongly recommended.", featured: true },
    { name: "Indiana BMV — New Haven", address: "1220 Lincoln Hwy E, New Haven, IN 46774", hours: "Mon–Fri: 8:30AM–6:00PM", note: "Serves New Haven and eastern Allen County. Full REAL ID processing available.", featured: false },
  ],
  airports: [
    {
      code: "FWA",
      name: "Fort Wayne International Airport",
      distance: "8 miles southwest of downtown Fort Wayne via I-69",
      address: "3801 W Ferguson Rd, Fort Wayne, IN 46809",
      note: "Primary airport for Fort Wayne and Northeast Indiana. Direct flights to Atlanta, Chicago, Detroit, and Dallas. Most international travel connects through Chicago O'Hare (ORD), Atlanta (ATL), or Detroit (DTW).",
      flightUrl: "https://fwairport.com/",
      flightLabel: "FWA Flight Info",
      featured: true,
    },
    {
      code: "IND",
      name: "Indianapolis International Airport",
      distance: "Approximately 2 hours south of Fort Wayne via I-69",
      address: "7800 Col. H. Weir Cook Memorial Dr, Indianapolis, IN 46241",
      note: "Alternative airport for Fort Wayne travelers. Direct flights to Toronto, Cancun, and Paris (seasonal). Larger hub with more domestic and international connections.",
      flightUrl: "https://www.ind.com/",
      flightLabel: "IND Flight Info",
      featured: false,
    },
    {
      code: "ORD",
      name: "Chicago O'Hare International Airport",
      distance: "Approximately 3 hours west of Fort Wayne via I-80/I-90",
      address: "10000 W O'Hare Ave, Chicago, IL 60666",
      note: "Major hub for Fort Wayne travelers seeking more international routes. United and American Airlines hub with global connections.",
      flightUrl: "https://www.flychicago.com/ohare/",
      flightLabel: "ORD Flight Info",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    { label: "Allen County: Birth & Death Certificates", url: "https://www.in.gov/health/vital-records/", icon: "ri-file-text-line", description: "Indiana Department of Health Vital Records — order birth and death certificates for Allen County and all Indiana counties" },
    { label: "Allen County Clerk: Marriage Licenses", url: "https://www.allencounty.us/", icon: "ri-heart-line", description: "Allen County Clerk — marriage license records for Fort Wayne and Allen County" },
    { label: "Allen County: Divorce Decrees", url: "https://www.allencounty.us/", icon: "ri-file-list-3-line", description: "Allen County Clerk of Courts — divorce decree records for Fort Wayne and Allen County" },
    { label: "VitalChek Nationwide Service", url: "https://www.vitalchek.com/", icon: "ri-global-line", description: "Order Indiana vital records online through VitalChek for delivery to your Fort Wayne address" },
  ],
};